module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Left 3-b7e0192052a1090ed0d453509f1470ad.svg";